<template>
  <el-card shadow="never" class="ymd_card sbu">
    <div slot="header" v-if="title">
      <h4>{{ title }}</h4>
    </div>
    <div>
      <el-form :label-width="labelWidth" :label-position="labelPosition">
        <el-form-item :label="language('ymdCardV2.timeType')" class="item">
          <el-select v-model="selectValue" placeholder="" clearable>
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="language('ymdCardV2.time')" class="item">
          <el-date-picker
            v-model="time"
            type="datetimerange"
            range-separator="-"
            :start-placeholder="language('ymdCardV2.startDate')"
            :end-placeholder="language('ymdCardV2.endDate')"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>
<script>
export default {
  props: {
    title: String,
    labelWidth: {
      type: String,
      default: "100px",
    },
    labelPosition: {
      type: String,
      default: "left",
    },
    startTime: {
      type: String,
      default: "startTime",
    },
    endTime: {
      type: String,
      default: "endTime",
    },
    options: {
      type: Array,
    },
    select: {
      type: String,
      default: "timeType",
    },
  },
  data() {
    return {
      time: "",
      selectValue: "",
    };
  },
  watch: {
    time: {
      handler() {
        let data = {};
        if (this.time && this.time.length > 0) {
          data[this.startTime] = this.time[0];
          data[this.endTime] = this.time[1];
        }
        data[this.select] = this.selectValue;
        this.$emit("change", data);
      },
    },
    selectValue: {
      handler() {
        let data = {};
        if (this.time && this.time.length > 0) {
          data[this.startTime] = this.time[0];
          data[this.endTime] = this.time[1];
        }
        data[this.select] = this.selectValue;
        this.$emit("change", data);
      },
    },
  },
};
</script>
<style >
.ymd_card .el-form-item__label {
  font-weight: 600;
}
</style>
<style scoped>
.item {
  margin-bottom: 10px;
}
.ymd_card {
  height: 100%;
}
</style>